import React from 'react'
import { Field } from 'redux-form'

import {
  makeStyles,
  styled,
  Switch,
  FormGroup,
  FormControlLabel,
  Tooltip,
  Input,
  Avatar
} from '@material-ui/core'
import { AvatarGroup } from '@material-ui/lab'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { isEmpty } from 'lodash'
import heic2any from 'heic2any'

import cameraSVG from '../../assets/icons/camera-icon.svg'
import crossAddSVG from '../../assets/icons/cross-add-icon.svg'
import searchIcon from '../../assets/icons/search-icon.svg'
import checkSVG from '../../assets/icons/check-icon.svg'

import { colors, roomDepartment } from '../../utils/constants'
import { numberFromText, handleAddAvatar } from '../../utils/helpers'
import { sortByQuery } from '../../utils/customSorter'
import { occupationsObject } from '../../utils/dicts'
import StyledSVG from '../shared/StyledSVG'
import UserAvatar from '../shared/UserAvatar'
import MaterialInput from '../shared/MaterialInput'
import CheckboxInput from '../input/CheckboxInput'
import Modal from '../modal/Modal'
import Button from '../button/Button'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    padding: '0px 40px',
    overflowY: 'scroll',
    overflowX: 'hidden'
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    margin: '16px 0px 32px 0px',
    '& p': {
      margin: 0,
      color: '#555555',
      fontSize: 12,
      fontWeight: 400
    },
    '& h2': {
      margin: 0,
      fontSize: 18,
      fontWeight: 600,
      color: '#386093'
    }
  },
  foto_section: {
    '& h2': {
      margin: '0px 0px 8px 0px',
      fontWeight: 600,
      fontSize: 16,
      color: '#375F92'
    }
  },
  input_photo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  photo_section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  },
  photo_preview: {
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: 140,
    height: 140,
    borderRadius: '50%'
  },
  float_edit_photo: {
    cursor: 'pointer',
    position: 'absolute',
    right: 0,
    bottom: 0,
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: '#386093CC',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  float_remove_photo: {
    cursor: 'pointer',
    position: 'absolute',
    right: 0,
    top: 0,
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: '#EF7C8FCC',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  remove_btn: {
    zIndex: 1,
    right: '-1px',
    top: '-1px',
    color: '#FFFFFF',
    margin: '5px'
  },
  photo_info: {
    fontWeight: 400,
    fontSize: 10,
    color: '#868E96'
  },
  photo_empty: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#D9D9D9',
    width: 140,
    height: 140,
    borderRadius: '50%',
    border: '1px dashed #868E96'
  },
  input: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& p': {
      margin: 0,
      fontWeight: 600,
      fontSize: 16,
      color: '#375F92'
    }
  },
  description: {
    '& .MuiInput-root': {
      minHeight: 150,
      maxHeight: 300,
      height: 'auto',
      display: 'flex',
      alignItems: 'flex-start',
      padding: '8px 12px',
      overflowY: 'scroll'
    },
    '& .MuiInputBase-inputMultiline': {
      resize: 'none',
      overflow: 'hidden'
    }
  },
  inputs_section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    marginTop: 32
  },
  switch_section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24
  },
  switch: {
    display: 'flex'
  },
  form_controll_root: {
    margin: 0
  },
  switch_label: {
    marginLeft: 13,
    '& h2': {
      fontWeight: 600,
      fontSize: 18,
      margin: 0
    },
    '& span': {
      fontSize: 14,
      fontWeight: 400,
      margin: 0,
      color: '#868E96',
      maxWidth: 380
    }
  },
  permissions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    marginTop: 32
  },
  persmissions_description: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& h1': {
      margin: 0,
      fontWeight: 600,
      fontSize: 16,
      color: '#386093'
    }
  },
  modal_btns: {
    display: 'flex',
    gap: 12,
    justifyContent: 'flex-end',
    marginBottom: 32
  },
  cancel_btn: {
    width: 146,
    border: '1px solid #EF7C8F',
    height: 44,
    padding: '14px 48px',
    gap: 10,
    color: '#EF7C8F',
    borderRadius: 8,
    '&:hover': {
      border: '1px solid #EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  send_btn: {
    backgroundColor: '#386093',
    width: 148,
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  modal_root: {
    height: 700,
    width: 500,
    display: 'flex',
    flexDirection: 'column'
  },
  modal_header: {
    display: 'flex',
    padding: 24,
    alignItems: 'center',
    gap: 8,
    height: '15%',
    backgroundColor: '#386093',
    '& h1': {
      margin: 0,
      color: '#FFFFFF',
      fontWeight: 600,
      fontSize: 24
    }
  },
  close_icon: {
    cursor: 'pointer',
    transform: 'rotate(45deg)',
    '& path': {
      stroke: '#FFFFFF'
    }
  },
  modal_body: {
    height: '85%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  member_list_section: {
    width: '100%',
    height: '100%',
    padding: '0px 18px',
    overflow: 'hidden',
    position: 'relative',
    '& .label': {
      textAlign: 'left',
      textTransform: 'uppercase',
      left: 18,
      color: '#66666680',
      fontSize: 14,
      fontWeight: 500,
      margin: 0
    }
  },
  search_component: {
    height: 50,
    margin: '18px 0px 24px 24px',
    width: '90%',
    padding: '8px 12px',
    borderRadius: 8,
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  contact: {
    margin: '8px 0px',
    padding: '8px 0px',
    display: 'flex',
    gap: 8,
    transition: 'background-color 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#ADB8CC33'
    },
    '& h1.user_name': {
      fontWeight: 500,
      fontSize: 16,
      color: '#555555',
      transition: 'color 0.3s ease-in-out'
    },
    '& p.user_occupation': {
      fontWeight: 400,
      fontSize: 12,
      color: '#9B9B9B',
      transition: 'color 0.3s ease-in-out'
    }
  },
  contact_name: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& h1': {
      margin: 0
    },
    '& p': {
      margin: 0
    }
  },
  selected_user_wrapper: {
    overflow: 'auto',
    height: '75%'
  },
  confirm_btn: {
    width: 70,
    height: 70,
    backgroundColor: '#386093',
    borderRadius: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: 32,
    right: 32,
    cursor: 'pointer'
  },
  edit_members: {
    fontWeight: 600,
    fontSize: 14,
    textDecoration: 'underline',
    color: '#386093',
    textDecorationColor: '#386093',
    cursor: 'pointer',
    margin: 0
  },
  active_user: {
    display: 'flex',
    alignItems: 'center',
    gap: 12
  }
}))

const CustomSwitch = styled(props => (
  <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#9DD2DA',
        opacity: 1,
        border: 0
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600]
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
    }
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: 'rgb(233, 233, 234)',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}))

const CreateChatGroupForm = ({
  history,
  handleUnselectForms,
  createChatRSPA,
  dataToCreateGroup,
  fieldValues,
  change,
  selectedUsers,
  setDataToCreateGroup,
  currentUserId,
  priorityOccupation
}) => {
  const classes = useStyles()
  const photoRef = React.useRef(null)
  const [photoBlob, setPhotoBlob] = React.useState(null)
  const hasPhoto = photoBlob
  const [canSubmit, setCanSubmit] = React.useState(null)
  const [switchModal, setSwitchModal] = React.useState({
    open: false,
    search_user: '',
    selected: [],
    groupMembers: [],
    checked: false
  })

  React.useEffect(
    () => {
      setSwitchModal(prev => ({
        ...prev,
        groupMembers: selectedUsers
      }))
    },
    [selectedUsers]
  )

  React.useEffect(
    () => {
      if (!isEmpty(dataToCreateGroup) && fieldValues?.name?.length > 0) {
        setCanSubmit(true)
      } else {
        setCanSubmit(false)
      }
    },
    [dataToCreateGroup, fieldValues]
  )

  const handleEditSelectedUsers = (closeModal, params) => {
    setDataToCreateGroup(prev => {
      const newStateChecked =
        switchModal.selected.length > 0 ? switchModal.checked : false
      const checked =
        params?.checked !== undefined ? params.checked : newStateChecked
      const selected =
        params?.selected !== undefined ? params.selected : switchModal.selected

      const oldRoomParticipants = prev.room_participants_attributes.map(
        item => {
          const { can_send_message, ...rest } = item
          return rest
        }
      )
      const newData = oldRoomParticipants.map(item => {
        const userSelected =
          selected.map(su => +su.user_id).includes(+item.user_id) ||
          currentUserId === item.user_id
        return {
          ...item,
          ...(checked ? { can_send_message: userSelected } : {})
        }
      })
      return {
        ...prev,
        room_participants_attributes: newData,
        read_only: checked
      }
    })
    if (closeModal) {
      setSwitchModal(prev => ({
        ...prev,
        open: false,
        checked: prev.selected.length > 0 ? prev.checked : false
      }))
    }
  }

  const handleSearchUser = event => {
    setSwitchModal(prev => {
      const newSortList = sortByQuery(
        prev.groupMembers,
        'user_name',
        prev.search_user
      )
      return {
        ...prev,
        groupMembers: newSortList
      }
    })
  }

  const handleCheck = (event, user) => {
    setSwitchModal(prev => {
      let newSelectedUsersValue
      if (event.target.checked) {
        newSelectedUsersValue = [...prev.selected, user]
      } else {
        newSelectedUsersValue = prev.selected.filter(
          u => u.user_id !== user.user_id
        )
      }
      return { ...prev, selected: newSelectedUsersValue }
    })
  }

  const handleSubmit = async () => {
    setCanSubmit(false)
    const response = await createChatRSPA(
      Object.assign(
        { ...dataToCreateGroup },
        {
          description: fieldValues.description,
          name: fieldValues.name,
          room_type: 0,
          ...(hasPhoto ? { cover_image: photoBlob } : {}),
          room_department: roomDepartment?.[priorityOccupation] || 0
        }
      )
    ).then(res => res)
    handleUnselectForms()
    if (response.data.data.id) {
      history.push(`/rooms/${response.data.data.id}`)
    }
  }

  const handleOnChangePhoto = event => {
    handleAddAvatar(
      event,
      null,
      alert,
      param =>
        setPhotoBlob(prevState => {
          change('photo_group', param)
          return param
        }),
      heic2any
    )
  }

  const handleDeletePhoto = () => {
    setPhotoBlob(null)
    change('photo_group', 'delete')
  }

  const handleSwitch = () => {
    setSwitchModal(prev => {
      const checkState = !prev.checked
      const newState = {
        ...prev,
        open: prev.checked ? false : !prev.open,
        checked: checkState,
        selected: checkState === false ? [] : prev.selected
      }
      handleEditSelectedUsers(false, newState)
      return newState
    })
  }

  const handleCloseModal = () => {
    handleEditSelectedUsers(true)
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <h2>Configurações do grupo</h2>
        <p>
          Personalize, configure e explore as ferramentas para criar um espaço
          ideal para o seu novo grupo.
        </p>
      </div>
      <div className={classes.foto_section}>
        <h2>Foto do grupo</h2>
        <div className={classes.input_photo}>
          <input
            accept='.png, .jpg, .jpeg, .heic'
            hidden
            name='photo_group'
            onChange={handleOnChangePhoto}
            ref={photoRef}
            type='file'
          />
          {hasPhoto && fieldValues?.photo_group !== 'delete' ? (
            <div className={classes.photo_section}>
              <div
                style={{
                  backgroundImage: `url(${URL.createObjectURL(photoBlob)})`
                }}
                className={classes.photo_preview}
              >
                <div
                  onClick={() => photoRef.current && photoRef.current.click()}
                  className={classes.float_edit_photo}
                >
                  <StyledSVG src={cameraSVG} width={20} height={20} />
                </div>
                <div className={classes.float_remove_photo}>
                  <HighlightOffIcon
                    className={classes.remove_btn}
                    onClick={() => handleDeletePhoto()}
                  />
                </div>
              </div>
              <span className={classes.photo_info}>
                Min. 200x200 px.<br />.png, .jpg, .jpeg ou .heic
              </span>
            </div>
          ) : (
            <div
              onClick={() => photoRef.current && photoRef.current.click()}
              className={classes.photo_section}
            >
              <div className={classes.photo_empty}>
                <StyledSVG src={cameraSVG} width={50} height={50} />
              </div>
              <span className={classes.photo_info}>
                Min. 200x200 px.<br />.png, .jpg, .jpeg ou .heic
              </span>
            </div>
          )}
        </div>
      </div>
      <div className={classes.inputs_section}>
        <div className={classes.input}>
          <p>Nome</p>
          <Field
            component={MaterialInput}
            name='name'
            type='text'
            autoComplete='off'
            placeholder='Nome do grupo'
          />
        </div>
        <div className={`${classes.input} ${classes.description}`}>
          <p>Descrição</p>
          <Field
            component={MaterialInput}
            withoutEndAdornment
            name='description'
            type='text'
            autoComplete='off'
            multiline
          />
        </div>
      </div>
      <div className={classes.permissions}>
        <div className={classes.persmissions_description}>
          <h1>Defina quem pode enviar mensagens neste grupo:</h1>
        </div>
        <FormGroup className={classes.switch_section}>
          <div className={classes.switch}>
            <FormControlLabel
              className={classes.form_controll_root}
              control={
                <CustomSwitch
                  disabled={!switchModal.groupMembers?.length > 0}
                  checked={switchModal.checked}
                  onClick={() => handleSwitch()}
                  sx={{ m: 1 }}
                />
              }
            />
            <div className={classes.switch_label}>
              <h2>Permitir que apenas alguns membros enviem mensagens</h2>
              <span>
                Restrinja o envio de mensagens a membros selecionados.
              </span>
            </div>
          </div>
        </FormGroup>
        {switchModal.checked &&
          switchModal.selected.length > 0 && (
            <div className={classes.active_user}>
              <AvatarGroup max={5} spacing={1}>
                {switchModal.selected.map((user, idx) => {
                  const index =
                    numberFromText(user.user_name?.slice(0, 2)) % colors.length
                  return (
                    <Tooltip
                      key={`user[${idx}]`}
                      title={user.user_name}
                      arial-label='usuario'
                    >
                      <Avatar
                        style={{
                          height: '30px',
                          width: '30px',
                          backgroundColor:
                            // eslint-disable-next-line standard/computed-property-even-spacing
                            colors[index]
                        }}
                      >
                        <p
                          style={{
                            fontSize: '14px',
                            fontWeight: 400,
                            lineHeight: '17px',
                            letterSpacing: '0em',
                            textAlign: 'left'
                          }}
                        >
                          {user.user_name[0]}
                        </p>
                      </Avatar>
                    </Tooltip>
                  )
                })}
              </AvatarGroup>
              <p
                onClick={() =>
                  setSwitchModal(prev => ({ ...prev, open: true }))
                }
                className={classes.edit_members}
              >
                Editar
              </p>
            </div>
          )}
      </div>
      <div className={classes.modal_btns}>
        <Button
          onclick={() => handleUnselectForms()}
          type='button'
          variant='outlined'
          className={classes.cancel_btn}
        >
          Cancelar
        </Button>
        <Button
          onClick={() => handleSubmit()}
          disabled={!canSubmit}
          className={classes.send_btn}
        >
          Continuar
        </Button>
      </div>
      <Modal
        open={switchModal.open}
        handleClose={handleCloseModal}
        disablePadding
      >
        <div className={classes.modal_root}>
          <div className={classes.modal_header}>
            <StyledSVG
              onClick={handleCloseModal}
              className={classes.close_icon}
              src={crossAddSVG}
              height={24}
              width={24}
            />
            <h1>Selecione os membros autorizados:</h1>
          </div>
          <div className={classes.modal_body}>
            <Input
              disableUnderline
              className={classes.search_component}
              placeholder='Busque pelo nome'
              onChange={event =>
                setSwitchModal(prev => ({
                  ...prev,
                  search_user: event.target.value
                }))
              }
              onKeyDown={event => {
                if (event.key === 'Enter') {
                  handleSearchUser()
                }
              }}
              value={switchModal.search_user}
              startAdornment={
                <StyledSVG
                  style={{ marginRight: 4 }}
                  src={searchIcon}
                  width={18}
                  height={18}
                />
              }
            />
            <div className={classes.member_list_section}>
              <p className='label'>Membros</p>
              <div className={classes.selected_user_wrapper}>
                {switchModal.groupMembers.length > 0 &&
                  switchModal.groupMembers.map((user, index) => {
                    const isSelected = switchModal.selected.some(
                      u => u.user_id === user.user_id
                    )
                    return (
                      <div className={classes.contact} key={index}>
                        <CheckboxInput
                          name={`user_${user.user_id}`}
                          checked={isSelected}
                          handleCheck={event => handleCheck(event, user)}
                        />

                        <UserAvatar
                          avatarUrl={user?.user_avatar}
                          userName={user.user_name}
                          withoutUserName
                        />
                        <div className={classes.contact_name}>
                          <h1 className='user_name'>{user.user_name}</h1>
                          <p className='user_occupation'>
                            {occupationsObject[user.user_occupation]}
                          </p>
                        </div>
                      </div>
                    )
                  })}
              </div>
              <div
                onClick={() => handleEditSelectedUsers(true)}
                className={classes.confirm_btn}
              >
                <StyledSVG src={checkSVG} width={40} height={40} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default CreateChatGroupForm
